import React from 'react';
import FolderBreadcrumbs from './FolderBreadcrumbs';
import FolderBreadcrumbsContainer, {
  OwnProps,
} from './FolderBreadcrumbs.container';

export default FolderBreadcrumbsContainer(
  FolderBreadcrumbs
) as React.ComponentType<OwnProps>;
